import { useFetchSubscriptionEventsQuery } from "../../../../../../redux/queries"
import { SubscriptionDetails } from "../../../../../../types"
import EngagementEventLog from "./event"
import { ActivityHistorySkeleton } from "../../../../skeletons"
import If from "../../../../if"

interface Props {
  data: SubscriptionDetails
}

const EngagementEvents = ({ data }: Props) => {
  const { data: events, isFetching } = useFetchSubscriptionEventsQuery(
    { subscription_id: data.id },
    { skip: !data.id }
  )

  return (
    <If
      condition={isFetching}
      then={<ActivityHistorySkeleton rows={3} className="mt-3" />}
      elseCondition={!!events && events.length !== 0}
      else={
        <>
          {events?.map((el, idx) => (
            <EngagementEventLog
              key={el.id}
              data={el}
              connectorVisible={idx < events.length - 1}
            />
          ))}
        </>
      }
      default={<div>No events found.</div>}
    />
  )
}

export default EngagementEvents
